import type { ReactNode } from 'react';

import { SiteFooter } from '@/designSystem/molecules/SiteFooter';

export interface PageWithFooterProps {
  children: ReactNode;
  /** Wrapper around main + footer (e.g. min-h-full flex flex-col). */
  className?: string;
  /** Main content region classes. */
  mainClassName?: string;
  /** Passed to SiteFooter (e.g. `bg-canvas`). */
  footerClassName?: string;
  'data-testid'?: string;
}

/**
 * Full-height page shell: growing main area + site footer pinned to the bottom.
 */
export function PageWithFooter({
  children,
  className = 'flex min-h-full flex-col bg-canvas text-primary',
  mainClassName = 'flex flex-1 flex-col',
  footerClassName = 'bg-canvas',
  'data-testid': dataTestId,
}: PageWithFooterProps) {
  return (
    <div data-testid={dataTestId} className={className}>
      <div className={mainClassName}>{children}</div>
      <div data-testid="agents-page-footer-slot" className="mx-auto w-full max-w-5xl px-4 pb-6 pt-4 md:px-0">
        <SiteFooter className={footerClassName} />
      </div>
    </div>
  );
}
